import React, {useState} from 'react';
import PropTypes from 'prop-types';
import store from "store";
import ListingTableCell from "../../../../../components/Product/Table/ListingTableCell";
import {Checkbox, Grid, TableRow, TextField} from "@mui/material";
import {ImageSharp} from "@mui/icons-material";
import {styled} from "@mui/material/styles";
import {blueColor, greyishBlue100, greyishBlue400, greyishBlue500, red600} from "../../../../../assets/jss/main";
import {BpCheckedIcon, BpIcon} from "../../../../../components/WMS/AccordionShipment/checkboxIcons";
import {FormattedMessage} from "react-intl";
import Badge from "../../../../../components/Badge";
import {LineItemStatusBadgeStyle} from "./components/LineItemStatusBadgeStyle";
import MultiRetailerOrder from "../MultiRetailerOrder";
import {useHistory} from "react-router-dom";
import CustomDate from "../../../../../components/date/date";
import CustomButton from "../../../../../components/CustomButton";
import InputTextField from "../../../../../components/input/new/InputTextField";
import { ReactComponent as BarcodeIcon } from "assets/img/barcode.svg";
import { ReactComponent as CrossIconSvg } from "assets/img/CrossIcon.svg";
import {ReactComponent as DotsIcon} from 'assets/img/wms/more.svg';
import {LineItemStatus} from "../../../../../utils/LineItemStatus";
import ColoredToast from "../../../../../components/coloredToast/ColoredToast";

const CrossIcon = styled(CrossIconSvg)(({ width = '16px', height = '16px' }) => ({
    width,
    height,
}));

ArticleRow.propTypes = {
    article: PropTypes.object.isRequired,
    itemWorkflowUpdate: PropTypes.func.isRequired
};

const imageFrame = {
    width: '84px',
    height: '112px',
    boxSizing: 'border-box',
    borderRadius: '8px',
    border: `1px solid ${greyishBlue100}`
};

const StyledImage = styled('img')({
    ...imageFrame,
    objectFit: 'cover',
    verticalAlign: 'middle'
});

const tableCellStyle = {
    lineHeight: "1.42857143",
    padding: "12px 8px",
    verticalAlign: "middle"
}

const articleNameLabelStyle = {
    color: greyishBlue500
}



function ArticleRow({article, itemWorkflowUpdate}) {
    if (LineItemStatus.TO_SHIP === article.status) {
        return
    }

    const [isSelected, setIsSelected] = useState(false);
    const [ticket, setTicket] = useState()

    const [openToast, setOpenToast] = useState(false)

    const history = useHistory();

    const locale = store.getState().currentOrganization?.retrieved?.defaultLocale;
    const retailerOptionValues = article.variation?.retailerOptionValues ?? [];
    const color = getOptionValueByCode(retailerOptionValues, 'Color', locale);
    const size = getOptionValueByCode(retailerOptionValues, 'Size', locale);

    let hasHover = false;

    function getOptionValueByCode(retailerOptionValues, type, locale) {
        const match = retailerOptionValues?.find(rov => rov.option?.type === type);
        if (!match) return null;
        return match.translations?.[locale]?.name ?? null;
    }

    const handleValidItem = () => {
        itemWorkflowUpdate(article, true)
    }

    return (
        <TableRow
            tabIndex={-1}
            key={article.id}
            aria-checked={isSelected}
            selected={isSelected}
            hover={hasHover}
        >
            <ListingTableCell style={tableCellStyle}>
                <Grid container flexWrap={"nowrap"} alignItems={"center"}>
                    <Grid item>
                        <Checkbox
                            icon={<BpIcon/>}
                            checkedIcon={<BpCheckedIcon/>}
                        />
                    </Grid>
                    <Grid item>
                        {article.pictures.length === 0 ?
                            <ImageSharp color={"disabled"} sx={{fontSize: '40px'}}/>
                            :
                            <StyledImage src={article.pictures[0]} alt={article.name}/>
                        }
                    </Grid>
                </Grid>
            </ListingTableCell>
            <ListingTableCell style={tableCellStyle}>
                <Grid container direction={"column"}>
                    <Grid item sx={{fontWeight: 'bold'}}>
                        {article.name}
                    </Grid>
                    {article.variation.product.brand.name && (
                        <Grid sx={articleNameLabelStyle} gap={"4px"} flexWrap={"nowrap"} container>
                            <span style={{whiteSpace: 'nowrap'}}><FormattedMessage id={"retailer.picking.itemList.articleName.brand"} /></span>
                            <span style={{color: "black"}}>{article.variation.product.brand.name}</span>
                        </Grid>
                    )}
                    {size && (
                        <Grid sx={articleNameLabelStyle} gap={"4px"} flexWrap={"nowrap"} container>
                            <span style={{whiteSpace: 'nowrap'}}><FormattedMessage id={"retailer.picking.itemList.articleName.size"} /></span>
                            <span style={{color: "black"}}>{size}</span>
                        </Grid>
                    )}
                    {color && (
                        <Grid sx={articleNameLabelStyle} gap={"4px"} flexWrap={"nowrap"} container>
                            <span style={{whiteSpace: 'nowrap'}}><FormattedMessage id={"retailer.picking.itemList.articleName.color"} /></span>
                            <span style={{color: "black"}}>{color}</span>
                        </Grid>
                    )}
                    {article.variation.product.sku && (
                        <Grid sx={articleNameLabelStyle} gap={"4px"} flexWrap={"nowrap"} container>
                            <span style={{whiteSpace: 'nowrap'}}><FormattedMessage id={"retailer.picking.itemList.articleName.ref"} /></span>
                            <span>{article.variation.product.sku}</span>
                        </Grid>
                    )}
                    {article.variation.barcode && (
                        <Grid sx={articleNameLabelStyle} gap={"4px"} flexWrap={"nowrap"} container>
                            <span style={{whiteSpace: 'nowrap'}}><FormattedMessage id={"retailer.picking.itemList.articleName.ean"} /></span>
                            <span>{article.variation.barcode}</span>
                        </Grid>
                    )}
                    {article.variation.sku && (
                        <Grid sx={articleNameLabelStyle} gap={"4px"} flexWrap={"nowrap"} container>
                            <span style={{whiteSpace: 'nowrap'}}><FormattedMessage id={"retailer.picking.itemList.articleName.variant"} /></span>
                            <span>{article.variation.sku}</span>
                        </Grid>
                    )}
                </Grid>
            </ListingTableCell>
            <ListingTableCell style={tableCellStyle}>
                <Grid container direction={"column"} gap={'8px'}>
                    <Grid item>
                        <Badge
                            label={<FormattedMessage id={"retailer.picking.itemList.status."+article.status}/>}
                            color={"statusColor"}
                            border={true}
                            themeExtension={LineItemStatusBadgeStyle[article.status]}
                        />
                    </Grid>

                    {article.order?.retailerCountWithPendingOrReversedLineItem > 1 &&
                        <Grid item>
                            <MultiRetailerOrder isMultiRetailer isNewTraduction />
                        </Grid>
                    }

                    <Grid item onClick={() => history.push(`/picking/orders/show/${article.order.id}`)}>
                        <span
                            style={{
                                color: blueColor,
                                cursor: "pointer",
                                whiteSpace: "nowrap"
                            }}
                        >
                            #{article.order.displayExternalId} ({article.order.productCount})
                        </span>
                    </Grid>

                    {article["createdAt"] &&
                        <Grid item sx={{color: greyishBlue500}}>
                            <CustomDate date={article["createdAt"]} inlineDate/>
                        </Grid>
                    }

                {/*    il manque le modfié par et on sera bon pour cette colonne pour cette donnée il faut voir comment fonctionne
                le s'affecter le produit et voir si on peut le détourner pour trigger à chaque modification du lineItem (dans un listener) */}

                </Grid>
            </ListingTableCell>
            <ListingTableCell style={tableCellStyle}>
                <Grid container direction={"column"} gap={'4px'}>
                    <Grid item>
                        <span style={{fontWeight: 'bold'}}>{article.shipments[0].shippingMethod.name}</span>
                    </Grid>
                    <Grid item>
                        <span style={{color: greyishBlue500}}>{article.order.customerBillingFirstname} {article.order.customerBillingLastname}</span>
                    </Grid>
                </Grid>
            </ListingTableCell>
            <ListingTableCell style={tableCellStyle}>
                <Grid container direction={"column"} gap={"4px"} flexWrap={"nowrap"}>
                    <Grid item>
                        <span style={{fontWeight: 'bold'}}>{article.boughtPrice}</span>
                    </Grid>
                    <Grid container item gap={"4px"} flexWrap={"nowrap"} sx={{color: greyishBlue500, whiteSpace: "nowrap"}}>
                        <FormattedMessage id={"retailer.picking.itemList.retailerPrice"}/>
                        <span>{article.retailerPrice}€</span>
                    </Grid>
                    <Grid container item gap={"4px"} flexWrap={"nowrap"} sx={{color: greyishBlue500, whiteSpace: "nowrap"}}>
                        <FormattedMessage id={"retailer.picking.itemList.refPrice"}/>
                        <span>{article.retailerOriginalPrice}€</span>
                    </Grid>
                </Grid>
            </ListingTableCell>
            <ListingTableCell style={tableCellStyle}>
                <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                    <Grid container item gap={"4px"} flexWrap={"nowrap"}>
                        <CustomButton style={{ fontWeight: '600', fontSize: '14px'}} color={"green"} onClick={() => handleValidItem()}>Préparer</CustomButton>
                        <CustomButton style={{minWidth: 0, width: '40px', minHeight: 0, height: '40px', padding: 0}} color={"lightRed"}><CrossIcon color={red600} /></CustomButton>
                        <CustomButton style={{minWidth: 0, width: '40px', minHeight: 0, height: '40px', padding: 0}} color={"idle"} variant={"nude"}><DotsIcon /></CustomButton>
                    </Grid>
                    <Grid item>
                        <InputTextField
                            value={ticket}
                            onChange={(event) => setTicket(event.target.value)}
                            InputProps={{
                                ['startAdornment']: (
                                    <BarcodeIcon />
                                )
                            }}
                            sx={{
                                width: '100%',
                                minWidth: '96px',
                                maxWidth: '192px',
                                maxHeight: '40px',
                                '& .MuiInputBase-root': {
                                    input: {
                                        padding: '12px 16px',
                                        "&::placeholder": {
                                            color: greyishBlue400,
                                            opacity: 1
                                        },
                                        fontWeight: '400'
                                    },
                                },
                            }}
                        />
                    </Grid>
                </Grid>
            </ListingTableCell>
        </TableRow>
    );
}
export default ArticleRow;